import { useEffect } from 'react';
import http from '../../../../../../utils/services/http';
import logger from '../../../../../../logger/logger';

import { hasAiHistory } from './aiToolStateSelector';
import { UseAiToolState } from './aiToolStateTypes';

import { CONVERSATION_HISTORY_LIMIT } from './aiToolStateConstants';

const useFetchConversationHistories = (props: UseAiToolState): void => {
    const { currentConversation, setConversationFetching, loadConversation, loadConversationStubs } = props;

    const fetchConversationStubs = async () => {
        try {
            const response = await http({
                url: 'ai/conversations',
                params: { limit: CONVERSATION_HISTORY_LIMIT },
            });
            const { conversations } = response.data;
            if (!conversations) return;

            loadConversationStubs(conversations);
        } catch (error) {
            logger.error('Error fetching conversation history stubs', error);
        }
    };

    useEffect(() => {
        const hasHistory = hasAiHistory(props);

        if (hasHistory) return;

        fetchConversationStubs();
    }, []);

    const fetchConversationHistory = async () => {
        if (!currentConversation) return;
        if (currentConversation.fetched || currentConversation.fetching) return;

        setConversationFetching(currentConversation._id, true);

        try {
            const response = await http({ url: `ai/conversations/${currentConversation._id}` });
            const { conversation } = response.data;
            if (!conversation) return;

            loadConversation(currentConversation._id, conversation);
            setConversationFetching(currentConversation._id, false);
        } catch (error) {
            logger.error('Error fetching conversation', error);
        }
    };

    useEffect(() => {
        fetchConversationHistory();
    }, [currentConversation]);
};

export default useFetchConversationHistories;
